import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFieldArray, useForm } from "react-hook-form";
import ButtonWrapper from "../../components/Button";
import { InfoBox, SummaryCard } from "../../components/StyledComponent";
import { Button, Table } from "react-bootstrap";
import InputWrapper from "../../layout/inputWrapper";
import AddIcon from "@mui/icons-material/Add";
import { useSelector } from "react-redux";
import { Paper, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import SortingAlphabatically from "../../reusableComponents/SortingAlphbatically";

const Step5 = ({ formData, handleTabChange, isEmployee }) => {
  const { t } = useTranslation();
  const { documents } = useSelector((state) => state.formMT);
  const tenantId = Digit.ULBService.getStateId();
  const { data, isLoading: isDataLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["MapSubPaymentHeads"]);
  const feeDetail = formData?.taxHeadEstimates?.[0];
  const [taxHead, setTaxHead] = useState([]);
  const paymentHeads = data?.BPA?.MapSubPaymentHeads;
  const isCompounding = formData?.natureOfConstruction === "Compounding";
  const isNew = formData?.natureOfConstruction === "New";
  const isAddition = formData?.natureOfConstruction === "Addition Extension" || formData?.natureOfConstruction === "Revision";
  const isRevalidation = formData?.natureOfConstruction === "Revalidation/Time Extension";
  console.log(paymentHeads, isCompounding, "paymentheads");

  const paymentHeadsDropdown = paymentHeads?.map((item) => ({
    name: item.label,
    label: item.label,
    value: item.label,
  }));
  const defaultValues = {
    ...formData,
    paymentHeads: formData?.paymentHeads || [{ feeType: "", plotBuildUpArea: "", rate: "" }],
  };
  const { handleSubmit, control, setValue, watch, reset } = useForm({ defaultValues });

  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "paymentHeads",
  });

  const handleAddInput = () => {
    append({ feeType: "", plotBuildUpArea: "", rate: "" });
  };
  const handleCalculate = async () => {
    const paymentHeads = watch("paymentHeads");
    const checkedheads = paymentHeads.filter((e) => e.checked);
    console.log({ paymentHeads, checkedheads }, "watchingPaymentHeads");
    formData.paymentHeads = checkedheads;
    const CalulationCriteria = [{ BPA: { ...formData }, tenantId: "up", feeType: "ApplicationFee" }];
    const data = await Digit.OBPSService.bpacalculate({ CalulationCriteria });
    console.log(data, "calculationData");
    setTaxHead(data?.Calculations?.[0]?.taxHeadEstimates?.[0]?.paymentHeads);
  };
  const calculateRate = (plotArea, ranges) => {
    console.log("rangesFromCalculate", ranges, plotArea);

    for (const range of ranges) {
      if (range.area.includes("-")) {
        const [min, max] = range.area.split("-").map(Number);
        if (plotArea >= min && plotArea <= max) {
          return range.rate;
        }
      } else if (range.area.endsWith("+")) {
        const base = parseInt(range.area);
        if (plotArea > base) {
          const additional = plotArea - base;
          const blocks = Math.ceil(additional / 1000);
          return (ranges.find((r) => r.area === "501-1000")?.rate || 0) + blocks * range.ratePerAdditional1000;
        }
      }
    }
    return 0; // default if no match
  };
  const totalTaxHeadAmount = taxHead?.reduce((sum, row) => sum + (parseFloat(row.amount) || 0), 0);
  const totalFeeAmount = parseFloat(feeDetail?.mapRate?.price) || 0;
  const totalAmount = totalTaxHeadAmount + totalFeeAmount;
  const onSubmit = (data) => {
    data.paymentHeads = taxHead;
    if (isCompounding) {
      handleTabChange(5, data, false);
    } else {
      handleTabChange(4, data);
    }
  };
  console.log("formDataInStep5", formData, formData?.taxHeadEstimates?.[0]?.mapRate?.price, feeDetail);
  return (
    <section className="groupContainer">
      <form onSubmit={handleSubmit(onSubmit)}>
        {formData?.isGovernmentBuilding && formData?.isGovernmentBuilding === "yes" ? (
          <React.Fragment>
            <SummaryCard className="formContainer">
              <div className="formHeaderContainer">
                <h2 className="formHeading">Fee Details</h2>
              </div>
              <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                <h4>No Fees Required For Government Buildings.</h4>
              </div>
            </SummaryCard>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SummaryCard className="formContainer">
              <div className="formHeaderContainer">
                <h2 className="formHeading">Fee Details</h2>
              </div>
              <div className="formInputContainer" style={{ display: "flex", justifyContent: "center" }}>
                <div style={{ width: "100%" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Plot Type:</b>
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{formData?.primaryUse}</td>
                      </tr>
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Total Builtup Area:</b> (SQM)
                          <br />
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{formData?.totalBuildUpArea}</td>
                      </tr>
                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Rate:</b> (₹)
                          <br />
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{feeDetail?.mapRate?.unitPrice}</td>
                      </tr>

                      <tr>
                        <td style={{ width: "50%", textAlign: "left", padding: "8px" }}>
                          <b>Total Fee:</b> (₹)
                        </td>
                        <td style={{ width: "50%", padding: "8px" }}>{isRevalidation ? feeDetail?.estimateAmount : feeDetail?.mapRate?.price}</td>
                      </tr>
                    </tbody>
                  </table>
                  {/* <InfoBox>
                                It will be sole responsible of LTP if fee less submitted will be recovered from LTP
                            </InfoBox> */}
                </div>
              </div>
            </SummaryCard>

            {!formData?.edcrNumber && !isCompounding && !isNew && !isAddition && !isRevalidation && (
              <Table bordered hover responsive className="formHeaderContainer" style={{ marginTop: "20px", width: "90%" }}>
                <thead style={{ background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)", color: "white" }}>
                  <tr>
                    <th style={{ width: "10%", padding: "4px" }}>Select</th>
                    <th style={{ width: "30%", padding: "4px" }}>Payment Heads</th>
                    <th style={{ width: "15%", padding: "3px" }}>
                      Build Up Area (SQM)
                      <br />
                    </th>
                    <th style={{ width: "15%", padding: "3px" }}>
                      Area by LTP
                      <br />
                    </th>
                    <th style={{ width: "15%", padding: "3px" }}>
                      Rate (₹)
                      <br />
                    </th>
                    {/* <th style={{ width: "15%", padding: "3px" }}>
                  Amount (₹)
                  <br />
                </th> */}
                  </tr>
                </thead>
                <tbody>
                  {paymentHeads?.map((item, index) => (
                    <tr key={item.id}>
                      <td>
                        <InputWrapper
                          type="checkbox"
                          name={`paymentHeads[${index}].checked`}
                          control={control}
                          containerStyles={{ padding: "0px", margin: "0" }}
                        />
                      </td>
                      <td>{item.label}</td>
                      {/* <td style={{ padding: "4px 4px 4px 8px" }}>
                    <InputWrapper
                      control={control}
                      hasLabel={false}
                      placeholder="Select payment head"
                      name={`paymentHeads[${index}].feeType`}
                      type="selectInput"
                      data={SortingAlphabatically(paymentHeadsDropdown)}
                      mandatory
                      validation={{
                        required: { value: true, message: "Please select the payment head" },
                      }}
                    />
                  </td> */}

                      <td>
                        <InputWrapper
                          name={`paymentHeads[${index}].plotBuildUpArea`}
                          hasLabel={false}
                          control={control}
                          placeholder="Enter area"
                          type="textInput"
                          width="12vw"
                        />
                      </td>

                      <td>
                        <InputWrapper
                          name={`paymentHeads[${index}].updatedAreaJE`}
                          hasLabel={false}
                          control={control}
                          placeholder="Enter area"
                          type="textInput"
                          defaultValue={item?.buildUpArea ? formData?.totalBuildUpArea : formData?.plotArea}
                          width="12vw"
                          height={"22px"}
                          className="paymentHeadInput"
                        />
                      </td>

                      <td>
                        <InputWrapper
                          name={`paymentHeads[${index}].rate`}
                          hasLabel={false}
                          control={control}
                          placeholder="Enter rate"
                          type="textInput"
                          width="12vw"
                          defaultValue={item.hasOwnProperty("rate") ? item.rate : calculateRate(formData?.plotArea, item.slabs)}
                        />
                      </td>

                      {/* {taxHead?.[0]?.paymentHeads && <td>{taxHead?.[0]?.paymentHeads[index].amount}</td>} */}
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}

            {!formData?.edcrNumber && !isCompounding && !isNew && !isAddition && !isRevalidation && (
              <Button
                variant="contained"
                color="success"
                className="gradientButton"
                size="medium"
                style={{ borderRadius: "24px" }}
                onClick={handleAddInput}
              >
                <span style={{ color: "white" }}>
                  <AddIcon />
                  Add More
                </span>
              </Button>
            )}
            {!formData?.edcrNumber && !isCompounding && !isNew && !isAddition && !isRevalidation && (
              <Button
                className="gradientButton mb-4"
                variant="contained"
                color="success"
                size="medium"
                style={{
                  color: "white",
                  borderRadius: "24px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "10px",
                  marginLeft: "50%",
                }}
                onClick={handleCalculate}
              >
                Calculate
              </Button>
            )}
            {!formData?.edcrNumber && !isCompounding && !isNew && !isAddition && !isRevalidation && (
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="fee table">
                  <TableHead>
                    <TableRow>
                      <TableCell color="white">Fee Type</TableCell>
                      <TableCell color="white" align="right">
                        Built Up Area (sqmt.)
                      </TableCell>
                      <TableCell color="white" align="right">
                        Rate (₹)
                      </TableCell>
                      <TableCell color="white" align="right">
                        Amount (₹)
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {taxHead?.map((row, index) => (
                      <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                        <TableCell component="th" scope="row">
                          {row.feeType}
                        </TableCell>
                        <TableCell align="right">{row.plotBuildUpArea}</TableCell>
                        <TableCell align="right">{row.rate}</TableCell>
                        <TableCell align="right">{row.amount}</TableCell>
                      </TableRow>
                    ))}
                    <TableRow key={0} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        Fee On Plot
                      </TableCell>
                      <TableCell align="right">{formData?.totalBuildUpArea}</TableCell>
                      <TableCell align="right">{feeDetail?.mapRate?.unitPrice}</TableCell>
                      <TableCell align="right">{feeDetail?.mapRate?.price}</TableCell>
                    </TableRow>
                    <TableRow sx={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
                      <TableCell colSpan={3} align="right">
                        <strong>Total Amount</strong>
                      </TableCell>
                      <TableCell align="right">
                        <strong>{totalAmount.toFixed(2)}</strong>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </React.Fragment>
        )}

        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#180c0c" }}
                onClick={() => handleTabChange(1)}
              />
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};
export default Step5;
